import { useState } from "react";
import { toast } from "sonner";
import { http, formatError } from "@/lib/api";
import { MapPin, Clock, Users } from "lucide-react";
import SectionHead from "@/components/home/SectionHead";

export default function PlayNearYou({ sessions }) {
  const [items, setItems] = useState(sessions || []);
  const join = async (s) => {
    try {
      const { data } = await http.post(`/play-sessions/${s.session_id}/join`);
      setItems(items.map((x) => (x.session_id === s.session_id ? { ...x, joined: data.joined, joined_count: data.joined_count, spots_left: data.spots_left } : x)));
      toast.success(data.joined ? `Joined ${s.title}` : `Left ${s.title}`);
    } catch (e) {
      toast.error(formatError(e));
    }
  };
  return (
    <section data-testid="play-near-section">
      <SectionHead title="Play Near You" />
      <div className="space-y-3">
        {items.map((s) => (
          <div key={s.session_id} data-testid="play-opportunity-card" className="rounded-2xl bg-white border border-[#0E395F]/10 overflow-hidden flex">
            <div className="w-24 shrink-0 bg-cover bg-center" style={{ backgroundImage: `url(${s.image})` }} />
            <div className="flex-1 p-4">
              <div className="flex items-center justify-between">
                <span className="text-[10px] font-black uppercase tracking-wider text-[#4A90E2]">{s.type}</span>
                <span className="text-[10px] font-bold text-[#005F19]">{s.spots_left} spots left</span>
              </div>
              <div className="font-bold pv-text-dark">{s.title}</div>
              <div className="flex items-center gap-3 text-xs text-[#5C7285] mt-0.5">
                <span className="inline-flex items-center gap-1"><Clock size={11} />{s.time}</span>
                <span className="inline-flex items-center gap-1"><MapPin size={11} />{s.distance_mi} mi</span>
                <span className="inline-flex items-center gap-1"><Users size={11} />{s.joined_count}</span>
              </div>
              <button
                data-testid="join-game-btn"
                onClick={() => join(s)}
                className={`mt-2 rounded-full px-4 py-1.5 text-xs font-black transition-colors ${s.joined ? "bg-[#0E395F] text-white" : "bg-[#BED445] text-black hover:bg-[#c9df55]"}`}
              >
                {s.joined ? "Joined ✓" : "Join Game"}
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
